import React from 'react';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const GridRow = ({ preCompLocation }) => (
  <tr>
    <td>{preCompLocation.preCompLocationName}</td>
    <td>{preCompLocation.preCompLocationAddress}</td>
  </tr>
);

const ClubPreCompGridLargeRead = ({ data, isLoading }) => (
  <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
    <thead>
      <tr>
        <th>Pre-Competitive Location Name</th>
        <th>Address</th>
      </tr>
    </thead>
    <tbody>
      {isLoading === true
        ? <tr><td colSpan="3">Loading...</td></tr>
        : data.length > 0
          ? data.map((preCompetitiveLocation, i) => <GridRow key={i} preCompLocation={preCompetitiveLocation} />)
          : <tr><td colSpan="3">No Pre-Competitive Programs</td></tr>
      }
    </tbody>
  </table>
);

export default ClubPreCompGridLargeRead;